/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Structured not-helpful reason categories for draft coach feedback.
 */
export type EvaluationFeedbackCategory = (typeof EvaluationFeedbackCategory)[keyof typeof EvaluationFeedbackCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EvaluationFeedbackCategory = {
  rephrased_my_work: 'rephrased_my_work',
  contradicted_earlier_advice: 'contradicted_earlier_advice',
  focused_on_formatting_or_references: 'focused_on_formatting_or_references',
  score_changed_without_real_edit: 'score_changed_without_real_edit',
  something_else: 'something_else',
} as const;
